

















































































/* eslint-disable @typescript-eslint/camelcase */

import Vue from "vue";
import { Form } from "element-ui";
import { axios } from "@/plugins";

export default Vue.extend({
  name: "Edit",
  props: {
    tenantId: { type: String }
  },
  data() {
    return {
      dialog: false,
      isEdit: false,
      loading: false,
      ruleForm: {
        id: "",
        projectName: "",
        description: "",
        resourceQuota: {
          limits_cpu: "3",
          limits_memory: "5Gi",
          requests_cpu: "2",
          requests_memory: "4Gi"
        }
      },
      last: {
        "limits.cpu": "",
        "limits.memory": "",
        "requests.cpu": "",
        "requests.memory": ""
      }
    };
  },
  computed: {
    rules: function() {
      if (this.isEdit) {
        return {};
      } else {
        return {
          projectName: [
            {
              required: true,
              type: "string",
              pattern: /(?=^[a-z])[a-z0-9-]*(?=[a-z0-9]$)/
            }
          ]
        };
      }
    }
  },
  methods: {
    show(data?: any) {
      if (data) {
        // 编辑模式
        this.initData(data);
        this.isEdit = true;
      } else {
        this.isEdit = false;
      }
      this.dialog = true;
      this.getQuota();
    },
    getQuota() {
      axios.get(`/tenant/info/${this.tenantId}`).then(res => {
        Object.keys(this.last).forEach(key => {
          if (res.data.data.resourceUsed) {
            // @ts-ignore
            this.last[key] = this.minus(
              res.data.data.resourceQuota[key],
              res.data.data.resourceUsed[key],
              key
            );
          } else {
            // @ts-ignore
            this.last[key] = res.data.data.resourceQuota[key];
          }
        });
      });
    },
    minus(val: string, val2: string, key: string) {
      const data = this.unite(val) - this.unite(val2);
      if (key.includes("cpu")) {
        if (data % 1000) {
          return `${data}m`;
        } else {
          return `${data / 1000}core`;
        }
      } else {
        const Gb = 1024;
        const Tb = 1024 * 1024;
        if (data < Gb) {
          return `${data}Mi`;
        } else if (data < Tb) {
          return `${data / Gb}Gi`;
        } else {
          return `${data / Tb}Ti`;
        }
      }
    },
    unite(val: string) {
      const unit = val.match(/(m|Mi|Gi|Ti)$/g);
      if (!unit) {
        return 1000 * parseInt(val);
      }
      switch (unit[0]) {
        case "m":
          return parseInt(val);
        case "Mi":
          return parseInt(val);
        case "Gi":
          return parseInt(val) * 1024;
        case "Ti":
          return parseInt(val) * 1024 * 1024;
        default:
          return parseInt(val);
      }
    },
    quit() {
      this.ruleForm = (this as any).$options.data().ruleForm;
      (this.$refs.ruleForm as Form).resetFields();
      this.dialog = false;
    },
    submit() {
      (this.$refs.ruleForm as Form).validate(vakid => {
        if (vakid) {
          this.loading = true;
          if (this.isEdit) {
            this.edit();
          } else {
            this.create();
          }
        }
      });
    },
    edit() {
      const data = Object.assign({}, this.ruleForm, {
        resourceQuota: {
          "limits.cpu": this.ruleForm.resourceQuota.limits_cpu,
          "limits.memory": this.ruleForm.resourceQuota.limits_memory,
          "requests.cpu": this.ruleForm.resourceQuota.requests_cpu,
          "requests.memory": this.ruleForm.resourceQuota.requests_memory
        }
      });
      axios
        .put("/project", data)
        .then(() => {
          this.$message.success("项目信息修改成功");
          this.quit();
          this.$emit("afterEdit");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    create() {
      const data = Object.assign({}, this.ruleForm, {
        resourceQuota: {
          "limits.cpu": this.ruleForm.resourceQuota.limits_cpu,
          "limits.memory": this.ruleForm.resourceQuota.limits_memory,
          "requests.cpu": this.ruleForm.resourceQuota.requests_cpu,
          "requests.memory": this.ruleForm.resourceQuota.requests_memory
        }
      });
      axios
        .post("/project", Object.assign({}, data, { tenantId: this.tenantId }))
        .then(() => {
          this.$message.success("项目创建成功");
          this.quit();
          this.$emit("afterEdit");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    initData(data: any) {
      for (const item in this.ruleForm) {
        if (Object.prototype.hasOwnProperty.call(this.ruleForm, item)) {
          (this.ruleForm as any)[item] = data[this.transform(item)];
        }
      }
    },
    transform(value: string) {
      if ("_".indexOf(value) === -1) return value;
      return value.replace(/_/g, ".");
    }
  }
});
